import {
  DATE_PARAM,
  PageQueryParams,
  SCHEDULER_PARAM,
  VIEW_DAY,
  VIEW_PARAM,
  VIEW_WEEK,
  ViewType,
} from './types';
import {
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  parse,
  isValid,
} from 'date-fns';
import type { ViewPresetConfig } from '@bryntum/scheduler-thin';

export function parsePageQueryParams(
  searchParams: URLSearchParams,
): PageQueryParams {
  const viewParam = searchParams.get(VIEW_PARAM);
  const view: ViewType =
    viewParam === VIEW_DAY || viewParam === VIEW_WEEK ? viewParam : VIEW_WEEK;

  const dateStr = searchParams.get(DATE_PARAM);
  let date: Date;
  if (dateStr) {
    const parsed = parse(dateStr, 'yyyy-MM-dd', new Date());
    date = isValid(parsed) ? parsed : new Date();
  } else {
    // default to today if no date is provided in the URL
    date = new Date();
  }

  const schedulerId = searchParams.get(SCHEDULER_PARAM);

  return { view, date, schedulerId };
}

export const getDateRangeForView = (date: Date, view: ViewType) => {
  if (view === VIEW_DAY) {
    return {
      startDate: startOfDay(date),
      endDate: endOfDay(date),
    };
  }

  return {
    startDate: startOfWeek(date, { weekStartsOn: 1 }),
    endDate: endOfWeek(date, { weekStartsOn: 1 }),
  };
};

const WEEK_VIEW_PRESET: ViewPresetConfig = {
  base: 'weekAndDay',
  tickWidth: 100,
  timeResolution: { unit: 'hour', increment: 1 },
  headers: [{ unit: 'day', dateFormat: 'ddd DD/MM' }],
};

export const getViewPreset = (view: ViewType): string | ViewPresetConfig =>
  view === VIEW_DAY ? 'hourAndDay' : WEEK_VIEW_PRESET;

export const getFillTicks = (view: ViewType): boolean =>
  view === VIEW_WEEK ? true : false;
